import { useLocation as useReactRouteLocation } from 'react-router-dom'

export const useLocation = useReactRouteLocation

export default useLocation
